import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserDataService} from '../services/userData.service';
import {AuthService} from '../services/auth.service';

export const isSignedInGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const userService = inject(UserDataService);
  const router = inject(Router);

  // Fetch all information about the user/Tenant
  // await authService.fetch();

  if (userService.isLoggedIn()) {
    return true;
  } else {
    userService.setPostSignInPage(state.url);
    return router.createUrlTree(['/auth/login']);
  }
};
